import httpPoller from "webutils/http-poller.service";

export default ($timeout, $parse) => ({
  restrict: "A",
  scope: true,
  link(scope, element, attrs) {
    var attempts = 0;
    var imagePollerDelay = parseInt(attrs.imagePollerDelay || 1000);
    var multiplier = parseFloat(attrs.imagePollerDelayMultiplier || 1.1);
    var imagePollerOnLoad =
      attrs.imagePollerOnLoad && $parse(attrs.imagePollerOnLoad);
    var imagePollerOnError =
      attrs.imagePollerOnError && $parse(attrs.imagePollerOnError);
    var src = attrs.src || attrs.ngSrc;

    let setIt = (imgUrl) => {
      var result = httpPoller({ url: imgUrl, get: true });
      result.then((res) => {
        element.attr({ src: imgUrl });
        imagePollerOnLoad &&
          imagePollerOnLoad(scope, { element, imgUrl, attrs });
      });
      return result;
    };

    setIt(attrs.imagePoller);

    if (attrs.imagePollerReload) {
      scope.$on(attrs.imagePollerReload, (e, newSrc, delay) => {
        element.attr({ src });
        var reloadUrl = newSrc || attrs.imagePoller || ""; //.replace(/https?:/gi, '');
        var concatenator = reloadUrl.indexOf("?") > 0 ? "&" : "?";
        reloadUrl += `${concatenator}${new Date().getTime()}=no-cache`;
        $timeout(() => setIt(reloadUrl), delay || imagePollerDelay);
      });
    }
  },
});
